<script setup lang="ts">
const tokenIconRef = ref();
</script>
<template>
  <span class="token-icon">
    <CurrencyEthereumIcon ref="tokenIconRef" />
    <VTooltip
      :activator="tokenIconRef"
      max-width="100"
      offset="8 0"
      location="bottom left"
    >
      <p class="tooltip">
        Token gated
      </p>
    </VTooltip>
  </span>
</template>
<style scoped lang="scss">
.token-icon {
  display: flex;
  align-items: center;
  height: spacings-get(6);
  color: colors-get(gray, 500);

  svg {
    width: spacings-get(4);
    height: spacings-get(4);
  }
}
</style>